import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { fetchDataError, fetchDataSuccess } from './actions'
import { DATA_REQUEST_ASYNC } from './constants'

const fetchDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DATA_REQUEST_ASYNC.INITIATE),
    mergeMap((action) =>
      api.resolutionCenter
        .getAffectedMailboxData(
          action.payload.mailboxId,
          state$.value.partnerOptions.selectedCompany?.value
        )
        .pipe(
          map((response) => fetchDataSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchDataError, error, [400]))),
          takeUntil(action$.pipe(ofType(DATA_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(fetchDataEpic)
